<template>
  <div class="only-mobile action-wrapper"
  v-if="this.$route.name === 'ProductsIndex' || this.$route.name === 'SearchIndex'"
  :class="{'background-white':this.$route.name == 'ProductsShow'}">
      <mobile-breadcrumbs-results/>
      <mobile-sort-filter
      v-if="this.$route.name === 'ProductsIndex' || this.$route.name === 'SearchIndex'"/>
      <product-language-option/>  
  </div>
</template>

<script>
import MobileBreadcrumbsResults from './MobileBreadcrumbsResults'
import MobileSortFilter from './MobileSortFilter'
import ProductLanguageOption from '../products/components/ProductLanguageOption'
export default {

    components:{
        MobileBreadcrumbsResults,
        MobileSortFilter,
        ProductLanguageOption
    }
}
</script>

<style scoped>
@media only screen and (max-width: 768px){
    .action-wrapper{
        /* padding: 10px; */
        display:flex;
        justify-content: flex-end;
        align-items: center; 
    }
    .action-wrapper > *{
        margin: 10px;
        margin-left: 5px;
    }
    .background-white{
        background-color: white;
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/MobileActionTop.vue